import React, { Component } from "react";
import { Grid, Row, Col, Button, Image } from "react-bootstrap";
import Header from "./Header.jsx";
import Banner from "./Banner.jsx";
import BackButton from "./BackButton.jsx";
import MembersGrid from "./MembersGrid.jsx";
import hyperlinks from "../../../src/util/hyperlinks";

export default class AdvisoryBoardMembers extends Component {
    render() {
        return (
            <Header showCorporateMembers={this.props.showCorporateMembers} flashes={this.props.flashes} currentUser={this.props.currentUser}>
                <Grid className="with-background advisory-board-members-page">
                    <Banner heading="Advisory Board Members" />
                    <Row>
                        <Col md={3}>
                            <BackButton href={hyperlinks["advisoryBoard"]} text="❮ The Board" />
                        </Col>
                        <Col md={3} mdOffset={6} className="text-right">
                            <Button className="see-all-members" href={hyperlinks["currentMembers"]}>{"See all members ❯"}</Button>
                        </Col>
                    </Row>
                    <Row>
                        <MembersGrid
                            members={JSON.parse(this.props.advisoryBoardMembers)}
                            showNames={true}
                            filterGroup={"Board Members"}
                            innovationAreas={this.props.innovationAreas}
                            innovationAreasFor={this.props.innovationAreasFor}
                            currentUser={this.props.currentUser}
                        />
                    </Row>
                </Grid>
            </Header>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/AdvisoryBoardMembers.jsx.erb